import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { Footer } from 'shared/ui';
import { BurgerMenu } from 'widgets/BurgerMenu/ui/BurgerMenu';

interface MainLayoutProps {
  children: ReactNode;
}

const LayoutWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #F6F9FC;
`;

const ContentWrapper = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const MainLayout: FC<MainLayoutProps> = ({ children }) => {
  return (
    <LayoutWrapper>
      <BurgerMenu/>
      <ContentWrapper>
        {children}
      </ContentWrapper>
      <Footer />
    </LayoutWrapper>
  );
};

export default MainLayout; 